import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { STAY_PLAN_TABLES, type StayPlanModule } from "@/lib/daycare-hotel/stayPlans";

export interface ActiveStayPlanContract {
  contractId: string;
  petId: string;
  petName: string;
  ownerName: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ContractRow = any;

function normalizeActiveStayPlanContract(row: ContractRow): ActiveStayPlanContract {
  return {
    contractId: row.id,
    petId: row.pet_id,
    petName: row.pet?.name ?? "",
    ownerName: row.owner?.name ?? "",
  };
}

export async function fetchActiveStayPlanContracts(
  module: StayPlanModule,
  planId: string,
): Promise<ActiveStayPlanContract[]> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase as any)
    .from(STAY_PLAN_TABLES[module].contracts)
    .select("id, pet_id, pet:pets(name), owner:owners(name)")
    .eq("plan_id", planId)
    .eq("status", "active");
  if (error) throw error;
  return ((data ?? []) as ContractRow[]).map(normalizeActiveStayPlanContract);
}

export const activeStayPlanContractsKey = (module: StayPlanModule, planId: string | null) =>
  ["active-stay-plan-contracts", module, planId];

export function useActiveStayPlanContracts(
  module: StayPlanModule,
  planId: string | null,
  enabled: boolean,
): UseQueryResult<ActiveStayPlanContract[]> {
  return useQuery({
    queryKey: activeStayPlanContractsKey(module, planId),
    enabled: enabled && Boolean(planId),
    queryFn: () => fetchActiveStayPlanContracts(module, planId as string),
  });
}
